export var LayoutCodes;
(function (LayoutCodes) {
    LayoutCodes["ONBOARDING"] = "onboarding";
    LayoutCodes["DASHBOARD"] = "dashboard";
    LayoutCodes["COMMON"] = "common";
    LayoutCodes["MANAGE_TRIPS"] = "manage-trips";
})(LayoutCodes || (LayoutCodes = {}));
